import React, { useState, useEffect, Fragment } from 'react';
import { useHistory } from "react-router-dom";
import UserMenu from './UserMenu';
import Tools from './Tools';
import Sidebar from './Sidebar';
import './css/Home.css';

import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import DatePicker from 'react-modern-calendar-datepicker';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import TaskTreeFilter from './TaskTreeFilter';
import CallStatusFilter from './CallStatusFilter';
import Alert from './Alert';

const NewCampaign = (props) => {
    const [sessionData, setSessionData] = useState({}); 
    const [error, setError] = useState(null);
    const history = useHistory();
    const [selectedDay, setSelectedDay] = useState(null);
    const [data, setData] = useState({});
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [loadingDetails, setLoadingDetails] = useState(false);
    const [loadingCreateCampaign, setLoadingCreateCampaign] = useState(false);
    const [resultFilter, setResultFilter] = useState(null);
    const [assigning, setAssigning] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [assignments, setAssignments] = useState([]);
    const [campaigns, setCampaigns] = useState([]);
    const [resetForm, setResetForm] = useState(false);


    const handleChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    const setTaskType = (taskType) => {
        setData({ ...data, ['taskType']: taskType });
    }

    const setContactType = (contactType) => {
        //setData({ ...data, ['contactType']: contactType });
        let changes={['contactType']: contactType, taskType:undefined};
        setData( {...data, ...changes});
    }

    const setCallStatusFilter = (callStatusFilter) => {
        setData({ ...data, ['callStatusFilter']: callStatusFilter });
    }

    const setIncludeAbandonmentsFilter = (includeAbandonmentsFilter) => {
        setData({ ...data, ['includeAbandonmentsFilter']: includeAbandonmentsFilter });
    }

    const handleChangeCompany = (event) => {
        getAssignments(event.target.value);
        let changes={
            [event.target.name]: event.target.value, 
            assignmentId:undefined} //remove assignmentId
        setData( {...data, ...changes});
    }


    useEffect(() => {
        if (!sessionStorage.getItem('sessionData')) {
            history.push('/login');
        } else {
            
            //get companies
            let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData')); 
            const options = {
                url: `${process.env.REACT_APP_URI_API_CRM}/companies`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': currentSessionData.token
                },
                params: {}
            };
            axios(options).then(response => {
                setCompanies(response.data);
            })
            .catch(function (error) {
                console.log("Error:", error.message);
                setError(error.message);
            });
        }

        console.log('🐞DEBUG llegue');
    }, []);


    useEffect(() => {
        if(data.filterCampaign==='NO'){
            let changes={callStatusFilter: undefined, contactType:undefined, taskType:undefined};
            setData( {...data, ...changes});
        }
    }, [data.filterCampaign]);

    const getAssignments = (companyId)=>{
        axios.get(`${process.env.REACT_APP_URI_API_CRM}/assignments`, {
            params: { companyId: companyId}
        })
        .then(function (response) {
            setAssignments(response.data);
        })
        .catch(function (error) {
            console.log("Error:", error.message);
            setError(error.message);
            //setLoading(false);
        });
    }

    const getCampaigns = (event)=>{
        let assignmentId = event.target.value;
        axios.get(`${process.env.REACT_APP_URI_API_CRM}/campaignsAssignment`, {
            params: { assignmentId: assignmentId}
        })
        .then(function (response) {
            setCampaigns(response.data);
            //setLoading(false);
        })
        .catch(function (error) {
            console.log("Error:", error.message);
            setError(error.message);
            //setLoading(false);
        });
    }


    const getCustomLocale = () => {
        const athenaCustomLocale = {
            months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',],

            // week days by order
            weekDays: [
                { name: 'Lunes', short: 'L', },
                { name: 'Martes', short: 'M', },
                { name: 'Miércoles', short: 'M', },
                { name: 'Jueves', short: 'J', },
                { name: 'Viernes', short: 'V', },
                { name: 'Sábado', short: 'S', isWeekend: true, },
                { name: 'Domingo', short: 'D', isWeekend: true, },
            ],

            // just play around with this number between 0 and 6
            weekStartingIndex: 6,


            // return a { year: number, month: number, day: number } object
            getToday(gregorainTodayObject) {
                return gregorainTodayObject;
            },

            // return a native JavaScript date here
            toNativeDate(date) {
                return new Date(date.year, date.month - 1, date.day);
            },

            // return a number for date's month length
            getMonthLength(date) {
                return new Date(date.year, date.month, 0).getDate();
            },

            // return a transformed digit to your locale
            transformDigit(digit) {
                return digit;
            },

            // texts in the date picker
            nextMonth: 'Próximo mes',
            previousMonth: 'Mes anterior',
            openMonthSelector: 'Selector de mes',
            openYearSelector: 'Selector de año',
            closeMonthSelector: 'Cerrar selector de mes',
            closeYearSelector: 'Cerrar selector de año',
            defaultPlaceholder: 'Seleccionar...',

            // for input range value
            from: 'De',
            to: 'a',


            // used for input value when multi dates are selected
            digitSeparator: ',',

            // if your provide -2 for example, year will be 2 digited
            yearLetterSkip: 0,

            // is your language rtl or ltr?
            isRtl: false,
        }

        return athenaCustomLocale;
    }

    const logout = () => {
        alert('Se sesión de usuario ha finalizado, es necesario que vuelva a iniciar sesión.');
        sessionStorage.clear();
        history.push('/login');
    }

    const buildFilter=()=>{
        let serviceParams = {};
        
        if (data.fileWithPhoneNumbers) {
            serviceParams.filterFileWithPhoneNumbers = data.fileWithPhoneNumbers;
        }

        if (data.campaignType && data.campaignType !== '') {
            serviceParams.campaignType = data.campaignType;
        }

        if (data.campaignName && data.campaignName !== '') {
            serviceParams.campaignName = data.campaignName;
        }

        return serviceParams;
    }

    
    const newCampaignClaroVentas = () => {
        let serviceParams = buildFilter();

        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        setLoadingFilter(true);
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/newCampaignClaroVentas`,
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            data: serviceParams
        };

        axios(options).then(response => {
            setLoadingFilter(false);
            toast.success('Una nueva campaña ha sido generada con los datos ingresados.', {
                duration: 5000,
                style: {
                    borderRadius: '10px',
                    background: '#333',
                    color: '#fff',
                },
            });
            resetFilter();
        }).catch(function (error) {
            console.log("Error:", error.message);
            setLoadingFilter(false);
        });
    }


    const resetFilter=()=>{

        setData({});
        setAssignments([]);
        setCampaigns([]);        
        setResultFilter(null);
        setAssigning(false);
        setResetForm(!resetForm);
    }


    const downloadDetails = () => {
        let serviceParams = buildFilter();
        serviceParams.resultType = 'details';

        setLoadingDetails(true);
        axios.get(`${process.env.REACT_APP_URI_API_CRM}/clientsDetails`, {
            params: serviceParams
        })
        .then(function (response) {
            setLoadingDetails(false);

            let csv = 'data:text/csv;charset=utf-8,' + response.data;
            let csvData = encodeURI(csv);
            window.open(csvData);
        })
        .catch(function (error) {
            console.log("Error:", error.message);
            setLoadingDetails(false);
        });
    }


    
    const createCampaignAndAssignExtract = () => {
        let serviceParams = buildFilter();
        serviceParams.campaignType=data.campaignType;
        serviceParams.resultType='details';
        serviceParams.campaignName = data.campaignName;
        serviceParams.count = resultFilter.count;
        serviceParams.totals = resultFilter.totals;

        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/campaign`,
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            data: serviceParams
        };

        setLoadingCreateCampaign(true);

        axios(options).then(response => {
            
            if (response.status === 200) {
                if(response.data.error){
                    setError(response.data.error);
                    setLoadingCreateCampaign(false);
                } else {
                    setError(null);
                    setLoadingCreateCampaign(false);
                    toast.success('Una nueva campaña ha sido generada para el filtro aplicado.', {
                        duration: 5000,
                        style: {
                            borderRadius: '10px',
                            background: '#333',
                            color: '#fff',
                        },
                    });
                }
            }
        })
        .catch(function (error) {
            if (error.response) {
                if(error.response.data ==='Unauthorized'){
                    logout();
                }
            }
        });

    }

      
    const uploadFile = (e) => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        let formData = new FormData();
        formData.append("file", e.target.files[0]);

        axios.post(`${process.env.REACT_APP_URI_API_CRM}/uploadFileOfClientIds`, formData, {
            headers: { "Content-Type": "multipart/form-data", 'Authorization': currentSessionData.token },
        }).then((response) => {
            setData({ ...data, ['fileWithPhoneNumbers']: response.data.fileOnServer })
        }).catch((error) => {
        console.log('🐞DEBUG error:',error);
        });
    };

    const clearFileInputSelection =()=>{
        document.querySelector('input[type=file]').value=null;
        setData({ ...data, ['fileWithPhoneNumbers']: undefined });
    }
    

    return (
        <div className="mainWrapper">
            <Toaster position="bottom-right" reverseOrder={false} />
            <Sidebar key={props.inboundConnectedQueues} softphoneConnectionStatus={props.softphoneConnectionStatus}/>
            <div className="main">
                {error?(
                    <Alert className="error mt20">Error: {error}.</Alert>
                ):null}

                <div className="headerWrapper">
                    <div className="titleWrapper">
                        <h1>Nueva Campaña ClaroVentas</h1>
                        <span className="upper">Seleccione el filtro para generar un subconjunto de datos para la campaña.</span>
                    </div>
                    <div className="flexWrapper"> 
                        {/* {sessionData.profile_desc === 'Supervisor' ? (
                            <NavMenu functionToRefreshParent={refreshCampaignsAndNotify}/>
                        ) : null} */}
                        <UserMenu profile={sessionData.profile_desc}/>
                    </div>
                </div>

                <div className="flexRow gap20">
                    <div className="flexCol">
                        <form className="export">
                           
                            <div className="flexRow">
                                <div className="flexCol inputWrapper fileInput x4">
                                    {data.fileWithPhoneNumbers?(<button className="clear" onClick={clearFileInputSelection}></button>):null}
                                    <label>Según archivo de teléfonos</label>
                                    <input type="file" key={resetForm} onChange={uploadFile} accept =".txt"/>
                                </div>
                            </div>
                        </form>
                        <button disabled={data.campaignName === undefined || data.campaignType === undefined || data.fileWithPhoneNumbers === undefined} className={(loadingFilter) ? 'default mainAction loading' : 'default mainAction'} onClick={newCampaignClaroVentas}>Crear nueva campaña</button>
                        {Object.keys(data).length > 0?(
                            <button className='default outline ml10' onClick={resetFilter}>Resetear filtro</button>
                        ):null}
                    </div>
                    <div className="flexCol">
                        
                        <div className="assign">
                            <div className="inputWrapper x3">
                                <label>Nombre campaña</label>
                                <input type="text" key={resetForm} name="campaignName" maxLength="50" onChange={handleChange} />
                            </div>
                            <div className="flexCol inputWrapper">
                                <label className='required'>Tipo campaña</label>
                                <div className="selectWrapper">
                                    <select key={resetForm} name="campaignType" onChange={handleChange} defaultValue={""}>
                                    <option value="" disabled hidden>seleccione ...</option>
                                    <option value="ASSISTED">Telefónica Asistida</option>
                                    <option value="PROGRESSIVE">Telefónica Progresiva</option>
                                </select>
                                </div>
                            </div>        
                        </div>
                       

                    </div>
                </div>

                
                <p className='debug'>Data:{JSON.stringify(data)}</p>
            
            </div>
        </div>
    );
}

export default NewCampaign;